import React, { useState } from "react";
import FormWrapper from "../../components/Timesheet/FormWrapper";
import TimeSheetShift from "../../components/Timesheet/TimeSheetShift";
import history from "../../routes/history";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { formatDate, getTimeZone } from "./../../shared/helpers";
import { configTimeSheetRequested, resetHeader } from "../../redux/actions";

const TimeSheetEndShift = () => {
  const {
    EndOffsetMs = moment("05:00 PM", "HH:mm A"),
    loading,
    ...rest
  } = useSelector((state) => state.configTimeSheetReducer);
  const configTimeSheetReducer = useSelector(
    (state) => state.configTimeSheetReducer
  );
  const dispatch = useDispatch();
  const [selectedTime, setSelectedTime] = useState(moment(EndOffsetMs));

  const getPayload = () => {
    try {
      const timeZone = getTimeZone();
      const utcOffsetMs = moment.utc(selectedTime).valueOf();
      return {
        WorkHours: { Period: rest.Period, Hours: rest.Hours },
        ShiftTime: {
          StartOffsetMs: rest.StartOffsetMs,
          EndOffsetMs: utcOffsetMs,
          StartDate: formatDate(rest.StartDate),
          EndDate: formatDate(rest.EndDate),
          TimeZone: timeZone,
        },
        TalentAccountId: rest.TalentAccountId,
        SkillListingId: rest.SkillListingId,
        GigId: rest.GigId,
        ProposalId: rest?.ProposalId || undefined,
        BidId: rest?.BidId || undefined,
        timeSheetId: rest?.timeSheetId,
      };
    } catch (error) {
      console.warn("error", error);
    }
  };

  const successCallBack = () => {
    history.replace("/managecandidate");
    dispatch(resetHeader());
  };

  const handleNext = () => {
    const payload = getPayload();
    dispatch(
      configTimeSheetRequested({ ...payload, callBack: successCallBack })
    );
  };

  const handleTimeChange = (e) => {
    setSelectedTime(e);
  };

  return (
    <FormWrapper
      pageTitle={"Configure Timesheet"}
      percent={80}
      nextFunction={() => handleNext()}
      backFunction={() => history.goBack()}
      loading={loading}
      nextBtnText={rest?.timeSheetId ? "Update" : "Submit"}
    >
      <TimeSheetShift
        label="End shift time"
        disabled={loading}
        {...{ selectedTime, handleTimeChange }}
      />
    </FormWrapper>
  );
};

export default TimeSheetEndShift;
